module.exports = __webpack_public_path__ + "static/app_icon_no_background.066f708c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/app_icon_no_background.png
// module id = 197
// module chunks = 114276838955818 216929306842663